export var getChildrenText = function getChildrenText(children) {
  if (Array.isArray(children) && children.length && children[0].type === 'String') {
    var _children$0$props;
    return (_children$0$props = children[0].props) === null || _children$0$props === void 0 ? void 0 : _children$0$props.text;
  } else if (typeof children === 'string') {
    return children;
  }
  return '';
};